<template>
  <!-- Pass a new field object with the corrected href -->
  <Link v-if="safeHref" :field="{ ...props.field, value: { ...props.field?.value, href: safeHref } }" />  
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Link } from '@sitecore-jss/sitecore-jss-vue';
import { LinkField } from '@sitecore-jss/sitecore-jss-vue/types/components/Link';

interface Props {
  field?: LinkField;
}

const props = defineProps<Props>();

/**
* Fix tel: and mailto: links if Sitecore prepended http://
* Keep normal links and anchors intact
*/

const safeHref = computed(() => {
  const link = props.field?.value;
  if (!link?.href) return null;

  let url = link.href;

  if (url.startsWith('http://tel:') || url.startsWith('http://mailto:')) {
    url = url.replace('http://', '');
  }

  if (link.anchor) {
    url += `#${link.anchor}`;
  }

  return url;
});
</script>